import { Box, Button } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import { getInterestedWorkers } from "../../../api/apiCall";
import { useAuth } from "../../../auth/auth";
import { useLocation, useNavigate } from "react-router-dom";

const Interests = () => {
  const {state} = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const { postId } = location.state || {};
  const [workers, setWorkers] = useState<any>([]);

  const getWorkers = async () => {
    const response = await getInterestedWorkers(state.user?.token, postId);
    setWorkers(response);
  }

  useEffect(() => {
    getWorkers();
  }, [])

  const handleClick = (userId: any) => {
    navigate(`/pace-team/resourcing/profile?workerId=${userId}`);
  };    

  const columns: any = [
    {
      field: "fullName",
      headerName: "Full Name",
      flex: 1,
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: "pts",
      headerName: "Post Code",
      flex: 1,
      align: 'center',
      headerAlign: 'center'
    },
    {
      field: "phoneNumber",
      headerName: "Phone Number",
      flex: 1,
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: "email",
      headerName: "Email",
      flex: 1,
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: "details",
      headerName: "Details",
      flex: 1,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: any) => (
        <Button
          variant="contained"
          onClick={() => handleClick(params.row.id)}
          style={{
            boxShadow: 'none',
            backgroundColor: '#6c757d'
          }}
        >
          Details
        </Button>
      )
    }
  ];

  return (
    <Box sx={{height: "800px", width: "70%", margin: '0 auto', mt: 4}}>
      <DataGrid
        rows={workers}
        columns={columns}
        disableRowSelectionOnClick
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 100,
            },
          },
        }}
        pageSizeOptions={[100]}
        sx={{
          "& .MuiDataGrid-columnHeaderTitle": {
            fontWeight: "bold",
            fontSize: 15
          },
          "& .MuiDataGrid-columnHeader": {
            backgroundColor: '#f0f0f0',
            color: "#000",
            fontWeight: "bold",
          },
          '& .disable-columns': {
            borderRight: '1px solid #bfbfbf'
          },
          '& .border-left': {
            borderLeft: '1px solid #bfbfbf',
          },
        }}
      />
    </Box>
  )
}

export default Interests;
